import React, { Component } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import './App.css';
import './Comman/assets/css/style.css'
import './Comman/assets/css/bootstrap.css'
import './Comman/assets/css/table-style.css'
import './Comman/vendor/font-awesome-4.7/css/font-awesome.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import IdleTimer from 'react-idle-timer'
import { Redirect } from 'react-router-dom';
import { logout, logOutAdmin } from '../src/SuperAdminLogin/actions/superAdminLoginAction'
import { MainComponent } from './Login/components/main';
import swal from 'sweetalert';


class App extends Component {
  constructor(props) {
    super(props)
    this.idleTimer = null
    this.handleOnAction = this.handleOnAction.bind(this)
    this.handleOnActive = this.handleOnActive.bind(this)
    this.handleOnIdle = this.handleOnIdle.bind(this)
  }

  componentDidMount() { 
window.addEventListener("beforeunload", this.onUnload); 
} 

componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onUnload);  
}

onUnload = e => { // the method that will be used for both add and remove event
    localStorage.clear();    
 } 

handleOnAction (event) {
  //console.log('user did something', event)
}

handleOnActive (event) {
  // console.log('user is active', event)
  // console.log('time remaining', this.idleTimer.getRemainingTime())
}

handleOnIdle (event) {
  // console.log('user is idle', event)
  // console.log('last active', this.idleTimer.getLastActiveTime())
  
  if(sessionStorage.getItem('id_super_admin_token')){
    var that = this;
    swal({
        title: "Session Expired !!",
        text: "Your session has been expired. Please login again!!",
        type: "success"
    }).then(function() {
      that.logout();
    });
  }
}

logout() { 
  logout(); 
  //window.location.href = "https://login.alitis.se/AlecomFirstResponderWeb/superadmin/login";
  window.location.href = "https://alitisapp.regionuppsala.se/AlecomFirstResponderWeb/superadmin/login";
 // window.location.href = "https://alitisdev.alitis.se/AlecomFirstResponderWeb/superadmin/login";
//window.location.href = "https://alitisdev.alitis.se/AlecomFirstResponderWeb/superadmin/login";
//  return <Redirect to="/superadmin/login" />; 
}
  render() {
    return (
      //  "homepage":"https://login.alitis.se/AlecomSvLCVGRWeb/",
      // "homepage":"https://alitisdev.alitis.se/AlecomSvLCVGRWeb/",
        // <Router>   
      <Router  basename="/AlecomFirstResponderWeb">  
        {/* <MainComponent></MainComponent>  */}
        <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          timeout={1000 * 60 * 15}
          onActive={this.handleOnActive}
          onIdle={this.handleOnIdle}
          onAction={this.handleOnAction}
          debounce={250}
        />
        <MainComponent />
      </Router>
    );
  }
}




export default App;

